import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("views");

export const viewsTransport = transport;
export const VIEWS_BASE_URL = baseUrl;
